"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.array.join");

require("core-js/modules/es.regexp.constructor");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.split");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.currentDomainRegex = exports.interceptorAllowedDomains = void 0;
var interceptorAllowedDomains = /^((ci|demo|qed|lab|qa|sat)(\d*($|\..*))?\.?)?(auth|bankfeeds|cs-user|csweb|mfa|onbalance|onboarding|onvio|recibos|samba)?\.?(onvio|onbalance|thomsonreuters|mypaysolutions)\.(ca|com|com\.ar|com\.au|com\.br|co\.uk|nl|us)$/;
exports.interceptorAllowedDomains = interceptorAllowedDomains;
var currentDomainRegex = new RegExp("^".concat(window.location.host.split('.').join('\\.'), "$"));
exports.currentDomainRegex = currentDomainRegex;
